const BudgetUseComponent = () => import('@/views/finance/BudgetUse/BudgetUseView')

export default [
    {
        path:'/BudgetUseIndex',
        name:'BudgetUseComponent',
        component:BudgetUseComponent
    }
]